import FeaturedCollectionView from '../components/featured_collections/FeaturedCollectionView';

window.featuredCollectionView = new FeaturedCollectionView ({
    el              : '.Carousels',
    viewName        : window.viewName,
    bus             : window.globalEvents,
    room            : window.OverDrive.currentRoom,
    patronSettings  : window.patronSettings
});
